module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7f848e761c790803ece92402ddc4a8d7.gif";